import { render, staticRenderFns } from "./IndividualExamPage.vue?vue&type=template&id=2af86580&scoped=true"
import script from "./IndividualExamPage.vue?vue&type=script&lang=js"
export * from "./IndividualExamPage.vue?vue&type=script&lang=js"
import style0 from "./IndividualExamPage.vue?vue&type=style&index=0&id=2af86580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af86580",
  null
  
)

export default component.exports